
import { getToken } from "@/utils/auth";
import Vue from 'vue'

Vue.directive('auth',{
  inserted(el, binding) {
    const isLoggedIn = getToken()
    if (binding.modifiers.not) {
      // v-auth.not 表示未登录时显示
      if (isLoggedIn) el.parentNode?.removeChild(el)
    } else {
      // 默认v-auth表示登录时显示
      if (!isLoggedIn) el.parentNode?.removeChild(el)
    }
  }
})
